function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

export function isPromise(o) {
  return _typeof(o) === 'object' && typeof o.then === 'function';
}
export var isFunction = function isFunction(input) {
  return input && {}.toString.call(input) === '[object Function]';
};
export function isJSONObjectType(obj) {
  return _typeof(obj) === 'object' && !Array.isArray(obj) && obj !== null;
}